import React, { useState } from "react";
import { Modal, Input } from "antd";
import useCreate from "hooks/useCreate";

const AddIssueKindProblemModal = ({ handleClose, refetch, issue_kind_id }) => {
  const [name, setName] = useState("");

  const { is_saving, create } = useCreate({
    path: "/issue_kind_problems",
    onSuccess: refetch,
  });

  const handleOk = async () => {
    try {
      await create({
        issue_kind_id,
        name,
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal
      style={{ top: 45 }}
      maskClosable={false}
      width={700}
      title="Dodaj najczęściej zgłaszany problem"
      open={true}
      onOk={handleOk}
      onCancel={handleClose}
      cancelText="Anuluj"
      okText="Dodaj"
      okButtonProps={{
        disabled: !name || is_saving,
        loading: is_saving,
      }}
    >
      <Input.TextArea
        style={{ margin: "20px 0" }}
        value={name}
        onChange={({ target: { value } }) => setName(value)}
        rows={4}
        maxLength={150}
        showCount={true}
      />
    </Modal>
  );
};

export default AddIssueKindProblemModal;
